var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelfieLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49987 1.95459L6.63623 4.00004L9.49987 6.0455V1.95459Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81818 1.13623H1.31818C0.866312 1.13623 0.5 1.50254 0.5 1.95441V6.04532C0.5 6.49719 0.866312 6.8635 1.31818 6.8635H5.81818C6.27005 6.8635 6.63636 6.49719 6.63636 6.04532V1.95441C6.63636 1.50254 6.27005 1.13623 5.81818 1.13623Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelfieLetter);
export default __webpack_public_path__ + "static/media/icon-selfie-letter.1472fbf40befa3bf6bd4eb5e9b188454.svg";
export { ForwardRef as ReactComponent };